import React from 'react';
import "../styles/Component3.css"
import {  Element } from "react-scroll";



const Component3 = () => {
  return (
    
        <Element name="contract-section" >
        <section id="contract-section" className="container_3">

        <h3 class="title-3"> 
        Contact Support
        </h3>

        <p class="content-3">For assistance, please reach out to our support team.</p>

        <div class="mail-container">
            <div class="edit-text-container">
                <input type="text" placeholder="Name" class="edit-text" />
                <input type="email" placeholder="E-mail" class="edit-text" />
            </div>

            <div class="edit-text-container" style={{height:200}}>
                <input type="text" placeholder="Contact Details" class="edit-text" />
            </div>

            <div class="button-container">
                <button class="submit-button">Submit</button>
            </div>
            </div>
        </section>
        </Element>
  
  );
};

export default Component3;  
